import tw from 'twin.macro';

export const StyledP = tw.p`
  first-letter:capitalize font-normal text-base leading-7 
`;
